import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import consts from './../../../main/consts';

import { debugPago, debugEditado, debugEntregue, debugCancelado } from '../../../state/order/actions';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  text: {
    marginBottom: 10,
  },
}));

export default function Debugger(props) {
  const [id, setId] = React.useState('');
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const goToButton = (numero) => (
    <Button onClick={() => history.push(`${consts.CONTEXT}/debug/${numero}`, { data: {} })}>
      Ver
    </Button>
  );

  const action = (fn) => () => {
    dispatch(fn(id, goToButton));
  }

  return (
    <div className={classes.root}>
      <Typography variant="caption" className={classes.text}>Simuladores</Typography>
      <TextField
        variant="outlined"
        label="Código Externo do Pedido"
        margin="dense"
        value={id}
        onChange={(e) => setId(e.target.value)}
      />
      <div>
        <Button color="primary" onClick={action(debugPago)}>Pago</Button>
        <Button color="primary" onClick={action(debugEditado)}>Editado</Button>
        <Button color="primary" onClick={action(debugEntregue)}>Entregue</Button>
        <Button color="primary" onClick={action(debugCancelado)}>Cancelar</Button>
      </div>
    </div>
  );
}